import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';
import { guruAuthorizationHeaders } from './authService';

const guruUrl = (path) => `${ApiConfig.baseUrl}/guru${path}`;

const request = async (method, path, data, params) => {
  const response = await axios({
    method,
    url: guruUrl(path),
    data,
    params,
    headers: guruAuthorizationHeaders(),
  });
  if (response.data?.success === false) {
    throw new Error(response.data.message || 'Permintaan gagal.');
  }
  return response.data;
};

export const fetchGuruDashboard = async () =>
  (await request('get', '/dashboard')).data || {};

export const fetchGuruStudents = async (search = '') => {
  const response = await request('get', '/siswa', undefined, { search, per_page: 100 });
  return response.data?.data || [];
};

export const fetchStudentActivity = async (studentId, month) =>
  (await request('get', `/siswa/${studentId}/aktivitas`, undefined, { month })).data || {};

export const fetchGuruPermits = async (status = 'menunggu') => {
  const response = await request('get', '/izin', undefined, { status });
  return response.data?.data || [];
};

export const fetchGuruPermitPhoto = async (permitId) => {
  const response = await axios.get(guruUrl(`/izin/${permitId}/foto`), {
    responseType: 'blob',
    headers: guruAuthorizationHeaders(),
  });
  return response.data;
};

export const decideGuruPermit = async (permitId, status) =>
  request('patch', `/izin/${permitId}`, { status });

export const fetchGuruJournals = async (kind = 'harian', status = 'menunggu') => {
  const response = await request('get', `/jurnal/${kind}`, undefined, { status });
  return response.data?.data || [];
};

export const decideGuruJournal = async (kind, journalId, status, catatanRevisi = '') =>
  request('patch', `/jurnal/${kind}/${journalId}`, {
    status,
    ...(status === 'perlu_revisi' ? { catatan_revisi: catatanRevisi } : {}),
  });

export const resetStudentPassword = async (studentId) =>
  request('post', `/siswa/${studentId}/reset-password`);

export const resetStudentSchedule = async (studentId) =>
  request('post', `/siswa/${studentId}/reset-jadwal`);

export const moveStudentDevice = async (studentId) =>
  request('post', `/siswa/${studentId}/move-device`);

export const changeGuruPassword = async (currentPassword, newPassword) =>
  request('patch', '/password', {
    current_password: currentPassword,
    new_password: newPassword,
    new_password_confirmation: newPassword,
  });
